import React from "react";
import { Typography, Divider, theme } from "antd";
import { formatEUR } from "./buyLicenseUtils";
import { useLanguage } from "src/providers/LanguageProvider";

const { Text } = Typography;

type InvoiceProfile = {
  CompanyName?: string;
  CompanyAddress?: string;
  CompanyPostalCode?: string;
  CompanyCity?: string;
  CompanyCountry?: string;
};

type Props = {
  monthlyTotal?: number;
  oneTimeTotal?: number;
  invoiceProfile?: InvoiceProfile | null;
};

function joinNonEmpty(parts: Array<string | undefined | null>, sep = ", ") {
  return parts.filter(Boolean).join(sep);
}

const BuyLicenseCheckoutSummary: React.FC<Props> = ({
  monthlyTotal = 0,
  oneTimeTotal = 0,
  invoiceProfile,
}) => {
  const { token } = theme.useToken();
  const { t } = useLanguage();

  return (
    <>
      <Divider orientation="left" style={{ margin: "8px 0" }}>
        {t("CHECKOUT_TITLE")}
      </Divider>

      <div
        style={{
          display: "grid",
          gap: 6,
          background: token.colorBgContainer,
          border: "1px solid " + token.colorBorder,
          borderRadius: 8,
          padding: 12,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text type="secondary">{t("MONTHLY_TOTAL")}</Text>
          <Text strong>
            {formatEUR(monthlyTotal)} {t("PER_MONTH_SHORT")}
          </Text>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text type="secondary">{t("ONE_TIME_TOTAL")}</Text>
          <Text strong>{formatEUR(oneTimeTotal)}</Text>
        </div>

        <Divider style={{ margin: "8px 0" }} />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text type="secondary">{t("LABEL_INVOICE_PROFILE")}</Text>
          <Text strong>
            {invoiceProfile?.CompanyName || t("NOT_SELECTED")}
          </Text>
        </div>

        {invoiceProfile && (
          <div style={{ fontSize: 12, opacity: 0.85 }}>
            {joinNonEmpty(
              [
                invoiceProfile.CompanyAddress,
                invoiceProfile.CompanyPostalCode,
              ],
            )}{" "}
            —{" "}
            {joinNonEmpty([
              invoiceProfile.CompanyCity,
              invoiceProfile.CompanyCountry,
            ])}
          </div>
        )}
      </div>
    </>
  );
};

export default BuyLicenseCheckoutSummary;
